<footer class="bg-forestdark text-cream/80">
  <div class="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-12 sm:px-6 md:grid-cols-4 lg:px-8">
    <div class="col-span-2 md:col-span-1">
      <p class="font-display text-lg font-semibold text-cream">GALOPA</p>
      <p class="mt-2 max-w-xs text-sm">
        Trusted sellers. Secure transactions. Confident riders. A marketplace for beautifully kept
        secondhand saddles.
      </p>
      <img
        src="assets/branding/australian-made-owned.png"
        alt="Australian Made and Owned"
        width="208"
        height="184"
        class="mt-5 h-16 w-auto"
      />
    </div>

    <div>
      <p class="text-sm font-semibold text-cream">Shop</p>
      <ul class="mt-3 flex flex-col gap-2 text-sm">
        <li><a routerLink="/shop" class="hover:text-cream">All Saddles</a></li>
        <li>
          <a routerLink="/shop" [queryParams]="{ discipline: 'dressage' }" class="hover:text-cream"
            >Dressage</a
          >
        </li>
        <li>
          <a
            routerLink="/shop"
            [queryParams]="{ discipline: 'jump-close-contact' }"
            class="hover:text-cream"
            >Jump / Close Contact</a
          >
        </li>
        <li>
          <a routerLink="/shop" [queryParams]="{ discipline: 'western' }" class="hover:text-cream"
            >Western</a
          >
        </li>
      </ul>
    </div>

    <div>
      <p class="text-sm font-semibold text-cream">Company</p>
      <ul class="mt-3 flex flex-col gap-2 text-sm">
        <li>
          <a [routerLink]="['/']" fragment="how-it-works" class="hover:text-cream">How It Works</a>
        </li>
        <li>
          <a [routerLink]="['/']" fragment="safety" class="hover:text-cream">Buyer Protection</a>
        </li>
        <li><a routerLink="/account/listings/new" class="hover:text-cream">Sell a Saddle</a></li>
      </ul>
    </div>

    <div>
      <p class="text-sm font-semibold text-cream">Support</p>
      <ul class="mt-3 flex flex-col gap-2 text-sm">
        <li><a routerLink="/help" class="hover:text-cream">Help &amp; FAQ</a></li>
        <li><a routerLink="/contact" class="hover:text-cream">Contact us</a></li>
        <li><a routerLink="/signup" class="hover:text-cream">Create an account</a></li>
        <li><a routerLink="/login" class="hover:text-cream">Log in</a></li>
      </ul>
    </div>
  </div>

  <div class="border-t border-cream/10">
    <div
      class="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-4 text-xs sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8"
    >
      <p>&copy; {{ year }} Galopa. All rights reserved.</p>
      <div class="flex gap-4">
        <a routerLink="/privacy" class="hover:text-cream">Privacy</a>
        <a routerLink="/terms" class="hover:text-cream">Terms</a>
      </div>
    </div>
  </div>
</footer>
